import { useEffect, useRef } from 'react';
import type React from 'react';

import { useCountryCode } from '#src/app/shared/hooks/l10n';
import { useCookiePrefAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

import { initMetaPixelScript } from './initMetaPixelScript';

export const MetaPixel: React.FC = () => {
	const marketingCookies = useCookiePrefAsync('marketing');
	const countryCode = useCountryCode();

	const metaPixelEnabled = isLoaded(marketingCookies) && marketingCookies.value && countryCode === 'US';
	const pixelInitialized = useRef(false);

	useEffect(() => {
		if (metaPixelEnabled && !pixelInitialized.current) {
			initMetaPixelScript();
			pixelInitialized.current = true;
		}
	}, [metaPixelEnabled]);

	return null;
};
